import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

const tickerData = [
  { sym: "BIST 100", val: "10,142.85", chg: 1.24 },
  { sym: "USD/TRY", val: "33.18", chg: -0.12 },
  { sym: "EUR/TRY", val: "35.92", chg: 0.08 },
  { sym: "ALTIN GR", val: "2,684", chg: 0.42 },
  { sym: "BRENT", val: "82.45", chg: -0.65 },
  { sym: "BIST 30", val: "11,254.20", chg: 1.08 },
  { sym: "GARAN", val: "94.20", chg: 2.15 },
  { sym: "AKBNK", val: "68.45", chg: 1.45 },
  { sym: "THYAO", val: "312.50", chg: -0.85 },
  { sym: "ASELS", val: "68.10", chg: 0.92 },
  { sym: "SISE", val: "42.85", chg: -0.32 },
  { sym: "KCHOL", val: "185.40", chg: 0.75 },
];

const MarketTicker = () => {
  const items = [...tickerData, ...tickerData];
  return (
    <div className="bg-white border-b border-slate-200 overflow-hidden">
      <div className="flex">
        <div className="shrink-0 bg-[#1c4d9c] text-white px-4 py-2.5 text-[12px] font-bold flex items-center tracking-wide">
          PİYASALAR
        </div>
        <div className="flex-1 overflow-hidden relative py-2.5 min-w-0">
          <div className="ticker">
            {items.map((t, i) => (
              <span
                key={i}
                className="inline-flex items-center gap-2 text-[13px] whitespace-nowrap mx-5"
              >
                <span className="font-semibold text-slate-700">{t.sym}</span>
                <span className="text-slate-800">{t.val}</span>
                <span
                  className={`inline-flex items-center gap-1 font-semibold ${
                    t.chg >= 0 ? "text-emerald-600" : "text-red-500"
                  }`}
                >
                  {t.chg >= 0 ? (
                    <TrendingUp className="w-3 h-3" />
                  ) : (
                    <TrendingDown className="w-3 h-3" />
                  )}
                  {t.chg > 0 ? "+" : ""}
                  {t.chg}%
                </span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketTicker;
